export default class PPAdressAutocomplete {

    #inputCodeId;
    #inputCityId;
    #inputCityName;
    #inputCityValidate;

    constructor(inputCodeId,inputCityId,inputCityName,inputCityValidate) {
        this.#inputCodeId = inputCodeId;
        this.#inputCityId = inputCityId;
        this.#inputCityName = inputCityName;
        this.#inputCityValidate = inputCityValidate;
    }

    main() {
        // console.log(this.#inputCodeId);
        // console.log(this.#inputCityId);

        jQuery( `#${this.#inputCodeId}` ).autocomplete({
            source: '/wp-content/themes/pp/inc/crm-form/scrm-search-pna.php',
            minLength: 2,
            select: (event, ui)=>{

                if(ui.item.id !== '0'){
                    this.onSelectPostCode(ui.item);
                } else {
                    ui.item.value = '';
                    this.emptyPostCity();
                }
            },
            search:     (event, ui) => {},
            response:   (event, ui) => {},
            change:     (event, ui) => {}
        }).data("ui-autocomplete")._renderItem = function (ul, item) {
            if(item.id === '0'){
                return jQuery('<li class="ui-state-disabled">'+item.label+'</li>').appendTo(ul);
            }else{
                return jQuery("<li>")
                    .append("<div>" + item.label + "</div>")
                    .appendTo(ul);
            }
        };

        document.querySelector(`#${this.#inputCodeId}`).addEventListener('input', (e)=>{
            this.emptyPostCity();
            e.target.value = this.formatZipCodePL(e.target.value);

            setTimeout(() => {

                let elementValidate = document.querySelector(`#${this.#inputCityValidate}`);
                if(elementValidate){
                    elementValidate.style.display = 'none';
                }

            }, 400);

        });
    }

    onSelectPostCode() {

        let data = new FormData();
        let options = [];
        data.append('country', 'Polska');
        data.append('id', ui.id);
        data.append('value', ui.value);

        let url = new URL (document.URL);
        let scrmUrlCity = url.origin + '/wp-content/themes/pp/inc/crm-form/scrm-search-city.php';
        let xhr = new XMLHttpRequest();
        xhr.onloadstart = (e)=> {
            this.xhrOnLoadStart();
        };

    }
    emptyPostCity() {
        console.log('emptyPostCity');
    }
    xhrOnLoadStart(){
        const elementPostCity = document.querySelector(`#${this.#inputCityId}`);
        const elementPostCityReset = document.createElement('div');
        elementPostCityReset.setAttribute('id', this.#inputCityId);
        elementPostCityReset.setAttribute('class', 'form-select');
        elementPostCityReset.innerHTML = '...Pobieranie danych...';
        elementPostCity.replaceWith(elementPostCityReset);
    }

    onSelectPostCode(ui) {
        let data = new FormData();
        let options = [];
        data.append('country', 'Polska');
        data.append('id', ui.id);
        data.append('value', ui.value);

        let url = new URL (document.URL);
        let scrmUrlCity = url.origin + '/wp-content/themes/pp/inc/crm-form/scrm-search-city.php';

        let xhr = new XMLHttpRequest();
        xhr.onloadstart = (e)=> {
            this.xhrOnLoadStart();
        };

        xhr.onreadystatechange = function(e) {
            // readyState:
            // 0: UNSENT - nie wywołano jeszcze open()
            // 1: OPENED - wywołano open()
            // 2: HEADERS_RECEIVED - otrzymano nagłówki
            // 3: LOADING - pobieranie odpowiedzi
            // 4: DONE - operacja zakończona
            // console.log('Stan żądania:', xhr.readyState);
        };

        xhr.onload = (e) => {
            if (xhr.status === 200) {
                this.xhrOnLoad(xhr.responseText);
            }
        };

        xhr.open('POST', scrmUrlCity, true);
        xhr.send(data);

    }

    xhrOnLoad(response) {{

        const obj = JSON.parse(response);
        const options = obj.options;

        const elementPostCity = document.querySelector(`#${this.#inputCityId}`);
        const elementPostCityReset = document.createElement('select');
        elementPostCityReset.setAttribute('name', this.#inputCityName);
        elementPostCityReset.setAttribute('id', this.#inputCityId);
        elementPostCityReset.setAttribute('class', 'form-select');
        elementPostCityReset.setAttribute('aria-required', 'true');
        elementPostCityReset.setAttribute('aria-invalid', 'false');

        options.forEach((name, value) => {
            const option = document.createElement('option');
            option.value = name;
            option.text = name;
            elementPostCityReset.appendChild(option);
        })

        elementPostCity.replaceWith(elementPostCityReset);

    }}

    emptyPostCity()
    {
        const elementPostCity = document.querySelector(`#${this.#inputCityId}`);
        const elementPostCode = document.querySelector(`#${this.#inputCodeId}`);

        if(elementPostCode.value.length<8) {
            const elementPostCityReset = document.createElement('input');
            elementPostCityReset.setAttribute('name', this.#inputCityName);
            elementPostCityReset.setAttribute('id', this.#inputCityId);
            elementPostCityReset.setAttribute('class', 'form-select');
            elementPostCityReset.setAttribute('aria-required', 'true');
            elementPostCityReset.setAttribute('aria-invalid', 'false');
            elementPostCityReset.setAttribute('readonly', 'readonly');
            elementPostCityReset.setAttribute('placeholder', 'Uzupełni się automatycznie po wybraniu kodu');
            elementPostCity.replaceWith(elementPostCityReset);
        } else {
            let obj;
            obj = {
                id: elementPostCode.value.replace(" - ", ""),
                value: elementPostCode.value,
                label: elementPostCode.value
            };
            this.onSelectPostCode(obj);
        }

    }

    formatZipCodePL(value) {
        if (!value) return '';
        const cleanedValue = value.replace(/\D/g, "");
        const match = cleanedValue.match(/^(\d{0,2})?(\d{0,3})?$/);

        return [
            match[1],
            match[2] ? " - " : '',
            match[2]
        ].join('');
    }

}